import * as Yup from "yup";

export const questionSchema = Yup.object({
    content: Yup.string().required("Question is required").trim(),
    type: Yup.string()
        .oneOf(["TEXT", "NUMBER", "OPTIONS"])
        .required("Type is required"),
    requiredField: Yup.boolean(),
    answerOptions: Yup.array()
        .of(
            Yup.object({
                content: Yup.string().required("Option text is required").trim(),
            })
        )
        .when("type", {
            is: "OPTIONS",
            then: (schema) => schema.min(1, "At least one option is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
});

export const validationSchema = Yup.object({
    questions: Yup.array().of(questionSchema).min(1, "At least one question is required"),
});
